import React from 'react';
import PropTypes from 'prop-types';
import SMSplitViewMixin from 'components/mixins/SMSplitViewMixin';
import SMDashboardBaseView from 'components/dashboard/shared/SMDashboardBaseView';
import SMUSettingMenuView from './SMUSettingMenuView';
import SMUSettingEditBasicFragmentView from './fragments/SMUSettingEditBasicFragmentView';
import SMUSettingEditContactFragmentView from './fragments/SMUSettingEditContactFragmentView';
import SMUSettingEditNotificationFragmentView from './fragments/SMUSettingEditNotificationFragmentView';
import SMUSettingEditPaymentFragmentView from './fragments/SMUSettingEditPaymentFragmentView';
import SMUSettingEditSecurityFragmentView from './fragments/SMUSettingEditSecurityFragmentView';
import SMUSettingEditBusinessAccountFragmentView from './fragments/SMUSettingEditBusinessAccountFragmentView';
import SMUSettingEditVerificationFragmentView from './fragments/SMUSettingEditVerificationFragmentView';
import SMHistoryHelper from 'components/helpers/SMHistoryHelper';
import SMAppHelper from 'components/helpers/SMAppHelper';
import reactMixin from 'react-mixin';

class SMUSettingEditView extends SMDashboardBaseView {

  constructor(props) {
    super(props);

    this.state = {
      selectedRowIndex: this.props.selectedRowIndex,
      user: this.props.user ? this.props.user.attributes : null,
      errors: [],
      pushStateUrl: "",
    };
  }

  componentDidMount() {
    $('body').addClass('js-split-view');
    window.addEventListener('resize', this.sizeToFit.bind(this), false);
    this.sizeToFit();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.sizeToFit.bind(this), false);
  }

  componentWillReceiveProps(nextProps) {

  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  componentDidUpdate(prevProps, prevState) {

  }

  tableDidSelectRowAtIndex(rowIndex) {
    let pushStateUrl, title;
    if (rowIndex == 0) {
      pushStateUrl = Routes.dashboard_settings_account_path();
      title = I18n.t('dashboard.label_000020');
    } else if (rowIndex == 1) {
      pushStateUrl = Routes.dashboard_settings_contact_path();
      title = I18n.t('dashboard.label_000181');
    } else if (rowIndex == 2) {
      pushStateUrl = Routes.dashboard_settings_verification_path();
      title = I18n.t('dashboard.label_000500');
    } else if (rowIndex == 3) {
      pushStateUrl = Routes.dashboard_settings_notification_path();
      title = I18n.t('dashboard.label_000023');
    } else if (rowIndex == 4) {
      pushStateUrl = Routes.dashboard_settings_payments_path();
      title = I18n.t('dashboard.label_000182');
    } else if (rowIndex == 5) {
      pushStateUrl = Routes.dashboard_settings_business_accounts_path();
      title = I18n.t('dashboard.label_001200');
    } else if (rowIndex == 6) {
      pushStateUrl = Routes.dashboard_settings_security_path();
      title = I18n.t('dashboard.label_000192');
    }

    this.setState({
      pushStateUrl: pushStateUrl,
      selectedRowIndex: rowIndex
    });
    $(this.refs.formContent).scrollTop(0);
    SMHistoryHelper.replaceState(pushStateUrl, this.state);
    SMAppHelper.setTitle(title);
  }

  sizeToFit(e) {
    let $mainTable = $(this.refs.formContent);

    $mainTable.outerHeight(this.mainTableHeight() - 74);
    this.mainTableFooterSizeToFit();
  }

  showSuccessMessage(){
    $(this.refs.formContent).showSuccessMessage(I18n.t("dashboard.notice_000001"));
  }

  showFailMessage(){
    $(this.refs.formContent).showFailMessage(I18n.t("dashboard.error_000001"));
  }

  render() {
    return (
      <div className="dashboard-container clearfix mb30">
        <SMUSettingMenuView delegate={this} selectedRowIndex={this.state.selectedRowIndex} />
        <div id="js-split_view-main" ref="formContent" className="dashboard-maincol__right js-scroller">
          <SMUSettingEditBasicFragmentView delegate={this} user={this.state.user} fragmentIndex={0} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditContactFragmentView delegate={this} user={this.state.user} fragmentIndex={1} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditVerificationFragmentView delegate={this} user={this.state.user} fragmentIndex={2} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditNotificationFragmentView delegate={this} user={this.state.user} fragmentIndex={3} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditPaymentFragmentView delegate={this} user={this.state.user} fragmentIndex={4} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditBusinessAccountFragmentView delegate={this} user={this.state.user} fragmentIndex={5} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
          <SMUSettingEditSecurityFragmentView delegate={this} user={this.state.user} fragmentIndex={6} selectedFragment={this.state.selectedRowIndex} errors={this.state.errors} />
        </div>
      </div>
    );
  }
}

SMUSettingEditView.propTypes = {
  user: PropTypes.object.isRequired,
  selectedRowIndex: PropTypes.number.isRequired,
};
reactMixin(SMUSettingEditView.prototype, SMSplitViewMixin);
export default SMUSettingEditView;



// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/users/settings/SMUSettingEditView.jsx